<template>
    <div>
        <v-dialog
            persistent
            v-model="display"
            width="500">
            <v-card>
                <v-card-title>{{ $t("USER_DISP_PG_TITLE") }}</v-card-title>
                <v-card-subtitle>{{ $t("USER_DISP_PG_SUBTITLE") }}</v-card-subtitle>
                <div class="text-center">
                    <v-progress-circular
                        indeterminate
                        v-if="!dataLoaded"
                        color="primary">
                    </v-progress-circular>
                </div>
                <v-card-text v-if="dataLoaded">
                    <v-simple-table>
                        <tbody>
                            <tr>
                                <th>{{ $t("USER_USERNAME") }}</th>
                                <td>{{user.username}}</td>
                            </tr>
                            <tr>
                                <th>{{  $t("USER_NAME") }}</th>
                                <td>{{user.name}}</td>
                            </tr>
                            <tr>
                                <th>{{ $t("USER_LAST_LOGIN") }}</th>
                                <td>{{user.last_login}}</td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                    <v-divider></v-divider>
                    <v-autocomplete
                        v-if="authorizations.users.update"
                        class="mt-4"
                        :label="$t('USR_DISP_PG_ROLES')"
                        v-model="form.roles"
                        multiple
                        :items="roles"
                        item-text="name"
                        item-value="id"
                        @blur="submit"
                        :loading="loading.roles">
                    </v-autocomplete>
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        text
                        @click="close">
                        {{ $t('BTN_CANCEL') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <RetryDialog
            ref="retryDialog"
            @submit="submitRetryDialog"/>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import RetryDialog from '../components/RetryDialog';
export default {
    name: "UserDisplayDialog",
    components: {
        RetryDialog
    },
    data() {
        return {
            tab: null,
            dataLoaded: false,
            display: false,
            form: {
                user_id: null,
                roles: null
            },
            loading: {
                roles: false
            }
        }
    },
    computed: { 
        ...mapState("user", ["user", "userRoles"]),
        ...mapState("workshop", ["workshops"]),
        ...mapState("role", ["roles"]),
        ...mapState("authentication", ["loggedInUser", "authorizations"])
    },
    methods: {
        ...mapActions('user', ["fetchUser", "updateUserRoles", "fetchUserRoles"]),
        ...mapActions("workshop", ["fetchAll"]),
        ...mapActions("role", ["fetchRoles"]),
        async open(params) {
            this.display = true;
            this.openParams = params;
            this.openDataFetch(this.openParams);
        },
        async openDataFetch(params) {
            try {
                await this.fetchUser(params.id);
                await this.fetchAll();
                await this.fetchRoles();
                await this.fetchUserRoles(params.id);
                this.form.user_id = this.user.id;
                this.form.roles = this.userRoles;
                this.dataLoaded = true;
            } catch(error) {
                let message = null;
                if(error.response) message = error.response.data.message;
                else message = error;
                this.$refs.retryDialog.open({target: "openDataFetch", message});
            }
        },
        submitRetryDialog(params) {
            if(params.target == "openDataFetch") {
                if(params.retry == true) this.openDataFetch(this.openParams);
                else this.close();
            }
        },
        close() {
            this.display = false;
            this.dataLoaded = false;
            this.form.user_id = null;
            this.form.roles = null;
            this.tab = null;
        },
        async submit() {
            this.loading.roles = true;
            this.updateUserRoles(this.form);
            this.loading.roles = false;
        }
    }
}
</script>